module.exports = "/_next/static/images/QuestThumbnail@2x-21e5796afa0003488944a1c171de52f7.webp";